import TimelineLink from './timeline-link.component'
import TimezoneAwareTime from 'src/components/timezone-aware-time/timezone-aware-time.component'
import { CurecallTag, CurecallTooltip, RoundInfoIcon } from '@honestica/curecall-ui'
import { twMerge } from 'src/utils/tw-merge.util'
import { TPatientMedAlert, MED_ALERT_UI_TO_TAG_STATUS } from 'src/types/med-alert'
import { TTimelineMedEventItem } from '../timeline.type'

type MedEventTimelineProps = {
  isLast: boolean
  medEvent: TTimelineMedEventItem
  index: number
}

const MedEventTimeline = ({ isLast, medEvent, index }: MedEventTimelineProps) => {
  const { date, label, done, matchingPatientMedAlerts: patientMedAlerts } = medEvent

  return (
    <>
      <TimelineLink done={done} />
      <div
        // eslint-disable-next-line react/no-unknown-property
        timeline-index={index}
        // eslint-disable-next-line react/no-unknown-property
        is-done={done ? 'true' : 'false'}
        className={twMerge('medevent', done && 'medevent--muted')}
        style={{
          paddingLeft: patientMedAlerts?.length ? 74 : '1.5rem',
        }}
      >
        <div className="c-flex c-flex-col c-items-center c-flex-1">
          <h6 className="c-mb-1">
            <div className="c-font-bold">{label}</div>
          </h6>
          <div>
            <TimezoneAwareTime date={date} formatter="date" variant="dark" />
          </div>
        </div>
        {patientMedAlerts?.length > 0 && (
          <CurecallTooltip
            content={patientMedAlerts.map((matchingAlert: TPatientMedAlert) => (
              <CurecallTag
                key={matchingAlert.id}
                status={MED_ALERT_UI_TO_TAG_STATUS[matchingAlert.MedAlert.ui]}
                className="c-m-2"
              >
                {matchingAlert.MedAlert.label}
              </CurecallTag>
            ))}
            contentWrapperClassName="tw-w-max"
          >
            <RoundInfoIcon className="c-text-[#ffb217] c-cursor-pointer c-bg-white c-rounded-full c-w-8 c-ml-4" />
          </CurecallTooltip>
        )}
      </div>
      {!isLast && <TimelineLink done={done} />}
    </>
  )
}

export default MedEventTimeline
